var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "kp1y8fhm3a",
    cx: 29.123,
    cy: 29.247,
    r: 28.603
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-620 -364) translate(570 361) translate(50 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ye62pbsbwb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kp1y8fhm3a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3D3D3D",
    d: "M29.5 35.611c3.757 0 5.47-.702 5.388-1.405-.083-.703-1.961-2.224-5.388-2.224-3.426 0-5.305 1.521-5.387 2.224-.082.703 1.63 1.405 5.387 1.405zm-12.815-7.84c4.671 8.657 7.56.227 12.815.227 5.252 0 8.143 8.422 12.81-.215l.024-.109c.827-.265 1.726-1.227 2.35-2.645.948-2.158.904-4.556-.1-5.356-1.135-.903-2.53.687-3.054 1.539-.144-3.302-.841-5.592-2.229-6.884-2.863-2.664-6.573-.185-9.8-.185-3.225 0-6.939-2.48-9.8.184-1.388 1.292-2.086 3.583-2.23 6.885-.525-.852-1.92-2.442-3.055-1.539-1.003.8-1.048 3.198-.099 5.356.623 1.416 1.52 2.377 2.346 2.644l.022.098zm6.643 14.403c-.46.575-1.002 1.106-1.638 1.583-.55.414-1.145.768-1.768 1.073 2.883 1.514 6.135 2.367 9.579 2.367 3.442 0 6.695-.853 9.577-2.367-.624-.305-1.217-.659-1.768-1.073-.636-.477-1.178-1.008-1.638-1.583-1.899 1.11-4.032 1.667-6.167 1.668-2.137 0-4.275-.556-6.177-1.668zm22.731 3.788c2.126.42 4.272.83 6.19 1.582 1.916.752 3.604 1.847 4.813 3.638C58.27 52.975 59 55.462 59 59H0c0-3.538.73-6.026 1.938-7.818 1.209-1.791 2.897-2.887 4.814-3.638 1.917-.753 4.063-1.162 6.19-1.582 2.605-.514 5.397-1.028 7.683-2.494.509-.326.984-.698 1.418-1.126.199-.195.388-.402.569-.621-.461-.315-.906-.665-1.33-1.05-3.504-3.183-4.351-7.959-5.347-12.39-1.091-.58-1.91-1.83-2.385-2.907-.48-1.091-.777-2.35-.754-3.548.018-1.008.28-2.165 1.102-2.82.38-.303.803-.437 1.23-.44-3.89-23.422 32.63-23.42 28.742 0 .428.002.851.136 1.233.44.822.655 1.084 1.812 1.102 2.82.022 1.197-.275 2.457-.754 3.548-.475 1.078-1.296 2.33-2.389 2.909-.997 4.429-1.835 9.195-5.336 12.38-.426.388-.873.74-1.337 1.058.18.22.37.426.568.621.434.428.91.8 1.419 1.126 2.286 1.466 5.077 1.98 7.683 2.494z",
    mask: "url(#ye62pbsbwb)"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMan);
export default __webpack_public_path__ + "static/media/icon-man.e362d5eb8f7d566d9374d48969442edb.svg";
export { ForwardRef as ReactComponent };